<template>
	<div class="zfjlmain">
		<div class="title">
			<div @click="showyf = true">{{currry}}<img src="../../assets/pull.png" alt=""></div>
		</div>
		<div class="sc">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
					<div class="xijie" v-for="(item,index) in list" :key="index">
						<div class="zi">
							<div class="ziup">
								<!-- <span :class="{green:item.status == '进入',red:item.status == '离开'}">{{item.status}}</span> -->
								<p v-if="item.bayonetin"><span class="green">进入</span>：{{item.bayonetin}} {{item.carin}}</p>
								<p v-if="item.bayonetout"><span class="red">离开</span>：{{item.bayonetout}} {{item.carout}}</p>
								<p v-if="item.parkingtime">停留时长：{{item.parkingtime}}</p>
							</div>
						</div>
						<!-- <div class="money" v-if="item.money">-{{item.money}}元</div> -->
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
		<van-popup v-model="showyf" round position='bottom'>
			<van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :min-date="minDate"
				:max-date="maxDate" :formatter="formatter" @confirm="onConfirmDate()" @cancel="showyf=false" />
		</van-popup>
	</div>
</template>
<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				showyf: false, //是否显示时间下拉框
				minDate: new Date(2020, 0, 1),
				maxDate: new Date(),
				currentDate: new Date(),
				currry: '',
				list: [],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum: 0,
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1
			}
		},
		mounted() {
			this.currry = this.timeFormat(this.currentDate);
		},
		computed: {
			...mapState(['userInfo', 'identity', 'houseId']),
		},
		methods: {
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					// 清空列表数据
					this.pageNum = 0;
					this.list = [];
					this.refreshing = false;
				}
				this.requestdata('/api/v1/wygl/inout/view')
			},
			requestdata(url) {
				this.$axios.get(url, {
					params: {
						pageNum: this.pageNum,
						pageSize: 15,
						houseId: this.houseId,
						year: this.year,
						month: this.month
					}
				}).then(res => {
					this.list.push(...res.data);
					this.pageNum++;
					this.loading = false;
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				});
			},
			formatter(type, val) {
				if (type === 'year') {
					return `${val}年`;
				} else if (type === 'month') {
					return `${val}月`;
				}
				return val;
			},
			timeFormat(time) { // 时间格式化 2019-09-08
				let year = time.getFullYear();
				let month = time.getMonth() + 1;
				let day = time.getDate();
				if (month < 10) month = "0" + month;
				if (day < 10) day = "0" + day;
				return year + '年' + month + '月'
			},
			onConfirmDate() {
				this.currry = this.timeFormat(this.currentDate) // 字符串拼接 结果入2020-07-03
				this.showyf = false;
				this.year = this.currentDate.getFullYear();
				this.month = this.currentDate.getMonth() + 1;
				this.refreshing = true;
				this.onRefresh();
			},
		},
	}
</script>
<style lang="less" scoped>
	p {
		margin: 0;
	}

	.sc {
		padding-top: 50px;
		min-height: calc(100vh - 46px);
	}

	.zfjlmain {
		background-color: #fff;
	}

	.xijie {
		height: 80px;
		width: 100%;
		display: flex;
		align-items: center;
		position: relative;
		background-color: #fff;
		border-bottom: 1px solid #f4f4f4;

		.zi {
			display: flex;
			flex-direction: column;
			width: 80%;

			.ziup {
				display: flex;
				flex-direction: column;
				padding: 0 10px;
				font-size: 14px;
			}

		}

		.money {
			position: absolute;
			right: 5%;
			font-weight: bold;
		}
	}

	.title {
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		width: 100%;
		padding: 10px 16px;
		overflow: hidden;
		color: #323233;
		font-size: 14px;
		line-height: 24px;
		background-color: #f4f4f4;
		position: fixed;
		top: 46px;
		left: 0;

		img {
			height: 20px;
			width: 20px;
			margin-left: 10px;
		}

		div {
			display: flex;
			align-items: center;
		}
	}

	.green {
		color: #03d194;
	}

	.red {
		color: #ff583c;
	}
</style>
